<template>
  <div>
    <zrsdqTx />
  </div>
</template>

<script>
// 获取接口地址
import zrsdqTx from '@/components/tztx/zrsdqTx'

export default {
  name: 'Zrsdqtx',
  components: {
    zrsdqTx
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
